import { Download } from "lucide-react";
import type { LegislationListComponent } from "../../types";
import { RuntimeLink } from "../../runtime/RendererRuntime";
import { isExternalHref } from "../../utils/links";

const DOWNLOAD_ICON_COLOR = "#FFC105";

/** Legislation document list renderer with download icon. */
export function LegislationListRenderer({ component }: { component: LegislationListComponent }) {
  const { items } = component.content;
  return (
    <section className="mt-4 md:mt-6">
      <ul className="space-y-3 md:space-y-4 list-none p-0 m-0">
        {items.map((item, idx) => {
          const openInNewTab = isExternalHref(item.href);
          return (
            <li key={`${item.label}-${idx}`}>
              <RuntimeLink
                href={item.href}
                className="inline-flex items-center gap-2 md:gap-3 text-[#00B862] underline hover:no-underline"
                {...(openInNewTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              >
                <span>{item.label}</span>
                <span className="shrink-0" style={{ color: DOWNLOAD_ICON_COLOR }} aria-hidden>
                  <Download className="h-5 w-5" stroke="currentColor" />
                </span>
              </RuntimeLink>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
